import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import innovation from "../../Assets/Projects/innovation.png";
import dp from "../../Assets/Projects/dp.png";
import oe from "../../Assets/Projects/oe.png";
import pa from "../../Assets/Projects/pa.png";
import od from "../../Assets/Projects/od.png";
import optimization from "../../Assets/Projects/optimization.png";
import laptopImg from "../../Assets/iVertex_black.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container> <img src={laptopImg} alt="about" className="img-fluid" width={250}/>
      <p></p>
        <h1 className="project-heading">
          We are the "Sommelier" of AI.<br></br>We will pair your problem/pain point
          <br></br>with the best AI tools and solution.
        </h1>
        <p style={{ color: "white" }}>Here are only a few examples.</p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={pa}
              isBlog={false}
              title="Predictive Analysis"
              description="Learning from data: AI uses machine learning to find patterns in past data.
Building models: It creates models based on those patterns.
Forecasting: It uses those models to predict future outcomes."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={optimization}
              isBlog={false}
              title="Optimization"
              description="Analyzing data: Identifying patterns and constraints.
Creating models: Representing the optimization problem.
Iterating and improving: Using algorithms to find the best solution within those constraints.
Adapting: Learning from results to refine the optimization process."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={oe}
              isBlog={false}
              title="Operational Efficiency"
              description="Automating tasks: Reducing manual work.
Optimizing processes: Streamlining workflows.
Predicting issues: Preventing downtime.
Analyzing data: Identifying inefficiencies."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={innovation}
              isBlog={false}
              title="Innovation"
              description="Generating new ideas: Through creative AI models.
Accelerating research: By analyzing vast datasets.
Automating design: Streamlining prototyping.
Predicting trends: Identifying future market needs."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={od}
              isBlog={false}
              title="Object Detection"
              description="Seeing images/video: Analyzing pixel data.
Learning patterns: Recognizing objects through training.
Finding objects: Locating them within the visual data.
Labeling objects: Identifying what they are."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dp}
              isBlog={false}
              title="Document Processing"
              description="Automating extraction: Grabbing key data.
Classifying documents: Sorting and organizing.
Understanding text: Reading and interpreting content.
Reducing errors: Improving accuracy and speed."
            />
          </Col>
        </Row>
      </Container>
      <h4>
        <center>
          Book a consultation<br></br> info@iVertex.ai{" "}
        </center>{" "}
      </h4>
    </Container>
  );
}

export default Projects;
